import React, { Fragment, useState, useCallback, useEffect } from 'react';
import TitleWithUnderline from '../../layout/TitleWithUnderline';
import { Divider, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Scrollbars from 'react-custom-scrollbars';
import Typography from '@material-ui/core/Typography';
import TextFields from '../../../control/textfield/TextFields';
import Grid from '@material-ui/core/Grid';
import { Field, getFormValues, reduxForm, reset } from 'redux-form';
import { useSelector } from 'react-redux';
import { validate } from './formValidator';
import AlertMessage from '../../../control/alert/AlertMessage';
import UseAlertMessageState from '../../../control/alert/UseAlertMessageState';
import { useDispatch } from 'react-redux';
import NoDataFound from './noDataFound';
import {
    postMeeting,
    getPublicMeetingById,
} from '../../../api/ApiMeetingPublic';
import AlertModal from '../AlertModal';
import { useParams } from 'react-router-dom';
import PublicDetail from '../PublicDetail';
import IconButton from '@material-ui/core/IconButton';
import { RemoveRedEye } from '@material-ui/icons';
import UseLoadingState from '../../../control/loading/UseLoadingState';
import Loading from '../../../control/loading/Loading';
import * as AlertMSGConstants from '../../../constants/AlertMSGConstants';
import ControlButton from '../../../control/button/Button';
import ModalImageFullScreen from '../../event/ModalImageFullscreen';

const formId = 'publicMeetingForm';

const PublicMeetingComponent = ({ handleSubmit }) => {
    const { bookingId } = useParams();
    const alertMessageState = UseAlertMessageState();
    const loadingState = UseLoadingState();
    const dispatch = useDispatch();
    const [errorMessage, setErrorMessage] = useState(null);
    const [fetchedDataError, setFetchedDataError] = useState({
        title: null,
        detail: null,
    });
    const [successMessage, setSuccessMessage] = useState(null);
    const [isFoundMeeting, setIsFoundMeeting] = useState(true);
    const [defaultValues, setDefaultValues] = useState({
        topic: '',
        chairman: '',
        dateDisplay: '',
        timeDisplay: '',
        meaDistrictName: '',
        building: '',
        imageName: [],
    });

    const useStyles = makeStyles((theme) => ({
        root: {
            width: '50%',
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            [theme.breakpoints.down('md')]: {
                width: '100%',
            },
        },
        rootPaper: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100%',

            ...theme.paperPadding,
        },
        modal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        expandBtn: {
            '&:hover': {
                backgroundColor: 'transparent',
                boxShadow: 'none',
            },
        },
        btnExpandText: {
            color: theme.palette.primary.main,
            fontSize: '24px',
            fontWeight: '600',
            textDecoration: 'underline',
            textDecorationColor: theme.palette.primary.main,
            textDecorationThickness: '1px',
            textUnderlineOffset: '3px',
        },
        btnExpandIcon: {
            color: theme.palette.primary.main,
            fontSize: '36px',
        },

        bannerWrapper: {
            position: 'relative',
            overflow: 'hidden',
            background: 'gainsboro',
            height: '377px',
            '&:hover $overlayButton': {
                opacity: 1,
                pointerEvents: 'auto',
            },
        },
        modalWrapper: {
            position: 'relative',
            height: '377px',
            overflow: 'hidden',
            '&:hover $overlayButton': {
                opacity: 1,
                pointerEvents: 'auto',
            },
        },
        image: {
            width: '100%',
            objectFit: 'cover',
            objectPosition: 'top',
        },
        imageModal: {
            width: '100%',
            height: '100%',
            objectFit: 'scale-down',
            objectPosition: 'top',
        },
        overlayButton: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            opacity: 0,
            transition: 'opacity 0.3s ease',
            backgroundColor: 'rgba(0,0,0,0.3)',
            color: 'white',
            border: 'none',
            padding: '10px 20px',
            borderRadius: '8px',
            cursor: 'pointer',
            pointerEvents: 'none',
            width: '53px',
            height: '53px',
        },
        topicName: {
            fontSize: '34px',
            fontWeight: '700',
            overflow: 'hidden',
            'text-overflow': 'ellipsis',
            display: '-webkit-box',
            '-webkit-line-clamp': 2,
            '-webkit-box-orient': 'vertical',
            wordBreak: 'break-all',
        },
        bookingNotFound: {
            display: 'flex',
            flexDirection: 'column',
            alignContent: 'center',
            justifyContent: 'center',
            height: '100%',
            textAlign: 'center',
            flexGrow: 1,
        },
        bookingNotFoundText: {
            color: '#EA4848',
            fontSize: '34px',
            fontWeight: '700',
        },
        meetingName: {
            fontSize: '34px',
            fontWeight: '700',
        },
        meetingDetail: {
            fontSize: '24px',
        },
        meetingValue: {
            fontSize: '24px',
        },
        noImage: {
            width: '100%',
            height: '100%',
            background: 'gainsboro',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: '40px',
            [theme.breakpoints.down('xs')]: {
                width: '100%',
            },
        },
        downloadInfo: {
            color: '#9E9E9E',
            fontSize: '24px',
            fontWeight: '400',
            textAlign: 'center',
            padding: '24px 0px 24px 0px',
        },
        downloadBtn: {
            backgroundColor: '#F78427',
            color: '#FFFFFF',
            height: '40px',
            borderRadius: '30px',
            fontSize: '20px',
            fontWeight: '700',
            width: '200px',
            justifyContent: 'space-around',
            padding: '8px',
        },
        infoExternal: {
            fontSize: '24px',
            fontWeight: '400',
            textAlign: 'center',
        },
        consentInfo: {
            color: '#9E9E9E',
            fontSize: '18px',
            lineHeight: '16px',
        },
        noDataFound: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            textAlign: 'center',
            flexGrow: 1,
        },
    }));
    const classes = useStyles();

    const submitPublicMeetingHandler = async (formValues) => {
        try {
            loadingState.showLoading();
            const response = await postMeeting(formValues, bookingId);
            if (response.errors && response.errors.length > 0) {
                throw new Error(response.errors[0].detail);
            }
            setSuccessMessage('ลงทะเบียนเข้าร่วมประชุมสำเร็จ');
            dispatch(reset(formId));
        } catch (error) {
            let altMsg = AlertMSGConstants.SYSTEM_ERROR;
            if (error.message) {
                altMsg = error.message;
            }

            setErrorMessage(altMsg);
        } finally {
            loadingState.hideLoading();
        }
    };

    const onSubmit = (formValues) => {
        alertMessageState.showAlert({
            altTitle: 'ยืนยันการลงทะเบียนเข้าร่วมการประชุม',
            altMsg: 'คุณต้องการยืนยันการลงทะเบียนเข้าร่วมการประชุมนี้ใช่หรือไม่',
            altType: 2,
            callbackCancel: () => alertMessageState.hideAlert(),
            callbackConfirm: () => {
                alertMessageState.hideAlert();
                submitPublicMeetingHandler(formValues);
            },
        });
    };

    const fetchData = useCallback(async () => {
        try {
            loadingState.showLoading();
            const response = await getPublicMeetingById(bookingId);
            if (response) {
                if (response.errors && response.errors.length > 0) {
                    throw response.errors[0];
                }
                if (response.data) {
                    const meetingData = response.data;
                    setDefaultValues(meetingData);
                }
            }
        } catch (error) {
            setIsFoundMeeting(false);
            setFetchedDataError({
                title: error.title,
                detail: error.detail,
            });
        } finally {
            loadingState.hideLoading();
        }
    }, [bookingId, loadingState]);

    const checkUserAndMeeting = useCallback(async () => {
        // Use custom schema for Android
        // Use AASA (file) for ios
        const deepLink = `${process.env.REACT_APP_CONNEXT_BUNDLE_ID}://meeting/checkin/${bookingId}`;

        const isAndroid = /Android/i.test(navigator.userAgent);

        if (isAndroid) {
            const now = Date.now();
            window.location = deepLink;

            setTimeout(() => {
                // If app is not opened within 2 seconds, fallback
                if (Date.now() - now < 2100) {
                    fetchData();
                }
            }, 1500);
        } else {
            fetchData();
        }
    }, [bookingId, loadingState]);

    const handleCloseModalError = useCallback(() => {
        setErrorMessage(null);
    }, []);

    const handleCloseModalSuccess = useCallback(async () => {
        setSuccessMessage(null);
        await fetchData();
        dispatch(reset(formId));
    }, [fetchData, dispatch]);

    const formValues = useSelector((state) =>
        getFormValues('publicMeetingForm')(state)
    );

    const isFormIncomplete = React.useMemo(() => {
        const errors = validate(formValues || {});
        return Object.keys(errors).length > 0;
    }, [formValues]);

    const [open, setOpen] = useState(false);
    const handleModalBehavior = useCallback(() => {
        setOpen((prev) => !prev);
    }, [setOpen]);

    useEffect(() => {
        checkUserAndMeeting();
    }, []);

    return (
        <Fragment>
            <Scrollbars universal={true}>
                <Paper className={classes.rootPaper}>
                    <div className={classes.root}>
                        <TitleWithUnderline title="ลงทะเบียนเข้าร่วมประชุม" />
                        {isFoundMeeting ? (
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '8px',
                                }}
                            >
                                <div className={classes.bannerWrapper}>
                                    {defaultValues.imageName &&
                                    defaultValues.imageName.length > 0 ? (
                                        <>
                                            <img
                                                src={defaultValues.imageName[0]}
                                                alt="img"
                                                className={classes.image}
                                                onClick={handleModalBehavior}
                                            />
                                            <IconButton
                                                onClick={handleModalBehavior}
                                                className={
                                                    classes.overlayButton
                                                }
                                            >
                                                <RemoveRedEye
                                                    color="primary.dark"
                                                    style={{
                                                        fontSize: 24,
                                                        opacity: 0.3,
                                                    }}
                                                />
                                            </IconButton>
                                        </>
                                    ) : (
                                        <div className={classes.noImage}>
                                            ไม่มีรูป
                                        </div>
                                    )}
                                </div>
                                <div>
                                    <Typography className={classes.topicName}>
                                        {defaultValues.topic}
                                    </Typography>
                                    <Grid container>
                                        {
                                            <>
                                                <Grid item xs={12} sm={6}>
                                                    <PublicDetail
                                                        fieldName="วันที่"
                                                        value={
                                                            defaultValues.dateDisplay
                                                        }
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <PublicDetail
                                                        fieldName="เวลา"
                                                        value={
                                                            defaultValues.timeDisplay
                                                        }
                                                    />
                                                </Grid>
                                            </>
                                        }
                                        <Grid item xs={12}>
                                            <PublicDetail
                                                fieldName="ประธาน"
                                                value={
                                                    defaultValues.chairman
                                                        ? defaultValues.chairman
                                                        : '-'
                                                }
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <PublicDetail
                                                fieldName="สถานที่"
                                                value={
                                                    defaultValues.meaDistrictName
                                                        ? defaultValues.meaDistrictName
                                                        : '-'
                                                }
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <PublicDetail
                                                fieldName="อาคาร"
                                                value={
                                                    defaultValues.building
                                                        ? defaultValues.building
                                                        : '-'
                                                }
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <PublicDetail
                                                fieldName="ห้องประชุม"
                                                value={
                                                    defaultValues.roomName
                                                        ? defaultValues.roomName
                                                        : '-'
                                                }
                                            />
                                        </Grid>
                                    </Grid>
                                </div>
                                <Divider />
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <Grid container spacing={2}>
                                        {[
                                            {
                                                label: 'ชื่อ',
                                                placeholder: 'ชื่อ',
                                                name: 'firstName',
                                            },
                                            {
                                                name: 'lastName',
                                                label: 'นามสกุล',
                                                placeholder: 'นามสกุล',
                                            },
                                            {
                                                label: 'ชื่อหน่วยงาน / ชื่อบริษัท',
                                                placeholder: 'หน่วยงาน',
                                                name: 'companyName',
                                            },
                                            {
                                                label: 'ตำแหน่ง',
                                                placeholder: 'ตำแหน่ง',
                                                name: 'position',
                                            },
                                            {
                                                label: 'อีเมล',
                                                placeholder: 'อีเมล',
                                                name: 'email',
                                            },
                                        ].map(
                                            ({ label, placeholder, name }) => (
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={6}
                                                    key={label}
                                                >
                                                    <Field
                                                        name={name}
                                                        label={label}
                                                        placeholder={
                                                            placeholder
                                                        }
                                                        component={TextFields}
                                                        required
                                                    />
                                                </Grid>
                                            )
                                        )}
                                    </Grid>

                                    <Divider
                                        style={{
                                            backgroundColor: '#f78427',
                                            marginBottom: '16px',
                                        }}
                                    />

                                    <Typography
                                        variant="caption"
                                        className={classes.consentInfo}
                                    >
                                        เมื่อท่านกด "ลงทะเบียน"
                                        เพื่อเข้าร่วมการประชุมนี้
                                        ถือว่าท่านได้ให้ความยินยอมแก่ผู้จัดงานในการเก็บรวบรวม
                                        และใช้ข้อมูลส่วนบุคคลของท่านที่ได้ให้ไว้
                                        เพื่อวัตถุประสงค์ในการดำเนินการประชุม
                                        การติดต่อสื่อสาร การจัดทำรายงานสรุป
                                        และกิจกรรมอื่นๆ ที่เกี่ยวข้อง ทั้งนี้
                                        ผู้จัดงานจะดำเนินการจัดเก็บและดูแลข้อมูลของท่านตาม
                                        มาตรการรักษาความปลอดภัยอย่างเหมาะสม
                                    </Typography>
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'end',
                                            paddingTop: '16px',
                                        }}
                                    >
                                        <ControlButton
                                            variant="contained"
                                            type="submit"
                                            label={'ลงทะเบียน'}
                                            disabled={isFormIncomplete}
                                        />
                                    </div>
                                </form>
                            </div>
                        ) : (
                            <div className={classes.noDataFound}>
                                <NoDataFound
                                    title={fetchedDataError.title}
                                    description={fetchedDataError.detail}
                                />
                            </div>
                        )}
                    </div>
                </Paper>
            </Scrollbars>
            <AlertMessage {...alertMessageState.altProps} />
            <Loading isShowLoading={loadingState.isShowLoading} />
            <AlertModal
                handleCloseModalError={handleCloseModalError}
                handleCloseModalSuccess={handleCloseModalSuccess}
                errorMessage={errorMessage}
                successMessage={successMessage}
            />
            {defaultValues.imageName && defaultValues.imageName.length > 0 && (
                <ModalImageFullScreen
                    img={defaultValues.imageName[0]}
                    open={open}
                    onClose={handleModalBehavior}
                />
            )}
        </Fragment>
    );
};

export default reduxForm({
    form: 'publicMeetingForm',
    validate,
})(PublicMeetingComponent);
